import React, { useEffect, useState } from "react";
import LiveIcon from "../../../../../../../assets/images/Souvenir/live.png";
import axios from "axios";
import SuperstarAuctionNav from "../../SupestarAuctionNav/SuperstarAuctionNav";
import ProductCardStar from "../../ProductCardStar";
import LoaderPost from "../../../../../../Reuseable/LoaderPost";

const PendingProductList = () => {
  const [pendingProduct, setPendingProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`/api/star/pending/auction/product/all`).then((res) => {
      if (res.status === 200) {
        setPendingProduct(res.data.products);
      }
      setLoading(false);
    });
  }, []);

  return (
    <>
      <SuperstarAuctionNav />
      <div className="d-flex mb-4  head-line p-3">
        <div className=" d-flex">
          <img src={LiveIcon} className=" SouvenirIcon" alt="" />
        </div>

        <div className=" d-flex text-light fw-bold mt-1 mx-3 ">
          Pending Product
        </div>
      </div>

      {loading ? (
        <LoaderPost />
      ) : (
        <ProductCardStar data={pendingProduct} noBidder="true" />
      )}
    </>
  );
};

export default PendingProductList;
